import styled from 'styled-components';
import ExpandingContentCard from '../../atoms/ContentCard';
import { MainPageContent } from '../../i18n/mainPageContent';
import { t } from 'i18next';
import { ActivityTopic, ActivityTopicsContainer, DotnetTechTopic, GodotTechTopic, ReaperTechTopic } from '../TechnologyTopic/TechnologyTopic';


const ActivityTopicOne = styled(ActivityTopic)`
  transform: rotate(-7deg);
  width: 33%;
`;

const ActivityTopicTwo = styled(ActivityTopic)`
  z-index: 2;
  width: 33%;
`;

const ActivityTopicThree = styled(ActivityTopic)`
  transform: rotate(6deg);
  width: 33%;
`;

const CurrentActivityWidget: React.FC<{}> = () => {
  return (
    <>
      <ExpandingContentCard>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <h3>{t(MainPageContent.currentlyWorkingTitle, { ns: ['main'] })}</h3>
        </div>
        <ActivityTopicsContainer>
          <ActivityTopicOne>
            <DotnetTechTopic/>
          </ActivityTopicOne>
          <ActivityTopicTwo>
            <GodotTechTopic/>
          </ActivityTopicTwo>
          <ActivityTopicThree>
            <ReaperTechTopic/>
          </ActivityTopicThree>
        </ActivityTopicsContainer>
      </ExpandingContentCard>
    </>
  );
};

export default CurrentActivityWidget;
